const basins = {
  id: "basins",
  label: "Basins",
  endpoint: "basins",
  columnConfig: [
    {
      field: "name",
      headerName: "Name",
      width: 250,
      description: "Basin Name",
      editable: true,
    },
    {
      field: "website_url",
      headerName: "Website",
      width: 250,
      description: "Basin Website",
      editable: true,
    },
    {
      field: "sciencebase_url",
      headerName: "ScienceBase URL",
      width: 250,
      description: "ScienceBase URL",
      editable: true,
    },
    {
      field: "people",
      headerName: "People",
      width: 250,
      description: "People",
      editable: true,
      renderCell: (params) => {
        const people = params.row.people;
        return (
          people
            ?.map(
              (person) =>
                `${person.person.first_name} ${person.person.last_name}`
            )
            .join(", ") || ""
        );
      },
      valueFormatter: (params) => {
        return (
          (params.value || [])
            ?.map(
              (person) =>
                `${person.person.first_name} ${person.person.last_name}`
            )
            .join(", ") || ""
        );
      },
      renderEditCellComponent: "SelectBasinPeople",
    },
    {
      field: "projects",
      headerName: "Projects",
      width: 250,
      description: "Projects",
      editable: true,
      renderCell: (params) => {
        const projects = params.row.projects;
        return projects?.map((project) => project.name).join(", ") || "";
      },
      valueFormatter: (params) => {
        return (
          (params.value || [])?.map((project) => project.name).join(", ") || ""
        );
      },
      renderEditCellProps: {
        multiple: true,
        categoriesEndpoint: "projects",
        categoriesEndpointResponseKey: "projects",
        categoriesEndpointResponseOptionsKey: "name",
      },
    },
  ],
  hiddenColumns: ["id"],
  chipConfig: {},
  tagConfig: {},
};

export default basins;
